namespace RioERP.Products {
    export interface ProductTeacherShareForm {
        RowIds: Serenity.StringEditor;
        ProductId: Serenity.LookupEditor;
        TeacherId: Serenity.LookupEditor;
        ESharingType: Serenity.EnumEditor;
        SharingAmount: Serenity.DecimalEditor;
    }

    export class ProductTeacherShareForm extends Serenity.PrefixedContext {
        static formKey = 'Products.ProductTeacherShare';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ProductTeacherShareForm.init)  {
                ProductTeacherShareForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = s.EnumEditor;
                var w3 = s.DecimalEditor;

                Q.initFormType(ProductTeacherShareForm, [
                    'RowIds', w0,
                    'ProductId', w1,
                    'TeacherId', w1,
                    'ESharingType', w2,
                    'SharingAmount', w3
                ]);
            }
        }
    }
}
